import { StateScheme } from 'app/providers/StoreProvider/config/StateScheme'

export const getChartMonthData = (state: StateScheme) => {
    return state.finance.chartMonthData
}
